






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import dealRoute from '@/routes/filebunker/deal';
@Component({
    computed: {
        totalPages() {
            if (this.$props.pagination.rowsPerPage == null ||
                this.$props.pagination.totalItems == null) {
                return 0;
            }

            return Math.ceil(this.$props.pagination.totalItems / this.$props.pagination.rowsPerPage);
        },
    },
    props: ['pagination', 'shownumbers'],
    watch: {
        'pagination.page': {
            handler(newValue) {
                this.page = newValue;
            },
            immediate: true,
        },
    },
})
export default class PaginationComponent extends Vue {
    public page: number = 1;
    public pageChanged(page: number): void {
        this.$emit('page-input', page);
    }
}
